import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=fc2c8f66&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=fc2c8f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2c8f66",
  null
  
)

export default component.exports